import { Flex, Text, SelectField, View } from "@aws-amplify/ui-react";
import { SetteiInputBox } from '../../../ui-components';
import {
  keisokuSettingJson,
  SETTING_ITEM_TYPE_INPUT,
  SETTING_ITEM_TYPE_SELECT,
  convertInputValueToSelctValue,
  convertSelectValueToInputValue,
  convertInputValueToSettingValue,
  convertSettingValueToInputValue,
  inputNumberLimit,
} from '../../../lib/SettingUtil';

const SpectrumAnalyzerSetting = ({
  editSettingJson,
  setEditSettingJson,
}) => {

  return (
    <>
      <Flex direction="column">
        {/* タイトル */}
        <Text
          fontFamily="Noto Sans"
          fontWeight="700"
          color="rgba(53,56,59,1)"
          lineHeight="16px"
          letterSpacing="0.65px"
          children="電波計測設定"
        />

        {/* 設定 */}
        <Flex
          direction="row"
          padding="0px 1px 0px 1px"
          gap="40px"
        >
          {
            Object.entries(keisokuSettingJson).map(([key, opt]) => {

              if (!editSettingJson) {
                return null;
              }

              // 設定
              const settingValue = editSettingJson[key];

              // 設定がない場合は表示しない
              if (!opt || settingValue == null) {
                return null;
              }

              if (opt.type === SETTING_ITEM_TYPE_INPUT) {
                return (
                  <SetteiInputBox
                    key={key}
                    attention="true"
                    label="true"
                    unit={opt.unit}
                    overrides={{
                      "dBm/MHz": {
                        children: opt.unit,
                      },
                      PositioningFrame: {
                        width: (
                          key == "Data Output Interval" ||
                          key == "Calibration Interval") ? "120px" : "170px",
                      },
                      TextField: {
                        width: "100%",
                        label: opt.label,
                        value: convertSettingValueToInputValue(opt.unit, settingValue),
                        placeholder: "",
                        ...opt.input,
                        onChange: (e) => {
                          setEditSettingJson({
                            ...editSettingJson,
                            [key]: convertInputValueToSettingValue(opt.unit, e.target.value),
                          });
                        },
                        onBlur: () => {
                          const val = convertSettingValueToInputValue(opt.unit, editSettingJson[key]);

                          const limitNumber = inputNumberLimit(val, opt.input.step, {
                            min: opt.input.min,
                            max: opt.input.max,
                          });

                          const convertedValue = convertInputValueToSettingValue(opt.unit, limitNumber);

                          setEditSettingJson({
                            ...editSettingJson,
                            [key]: convertedValue,
                          });
                        },
                      },
                      Attention: {
                        children: opt.input.min != null && opt.input.max != null
                          ? `範囲：${opt.input.min}-${opt.input.max}`
                          : "",
                      },
                    }}
                  />
                )
              }

              if (opt.type === SETTING_ITEM_TYPE_SELECT) {
                return (
                  <View
                    key={key}
                    width="152px"
                    height="87px"
                  >
                    <SelectField
                      width="152px"
                      label={opt.label}
                      size="small"
                      fontSize="0.875rem"
                      gap={"0.25rem"}
                      options={opt.options}
                      value={convertInputValueToSelctValue(opt.label, settingValue)}
                      isDisabled={false}
                      labelHidden={false}
                      variation="default"
                      onChange={(e) => {
                        console.log(e.target.value);
                        console.log(convertSelectValueToInputValue(opt.label, e.target.value));
                        setEditSettingJson({
                          ...editSettingJson,
                          [key]: convertSelectValueToInputValue(opt.label, e.target.value)
                        });
                      }}
                    />
                  </View>
                )
              }
            })
          }
        </Flex>
      </Flex>
    </>
  );
};

export default SpectrumAnalyzerSetting;